import { ornaments, type BotUser } from '@fakerpg/core';
import { Sprite } from '../assets/Sprite.js';

/** The player's name framed by the equipped ornament (`ornements.equip` in the bot). */
export function PlayerName({ save, size = 26 }: { save: BotUser; size?: number }) {
  const equip = save.ornements.equip;
  const def = equip.id ? ornaments[equip.id] : undefined;
  return (
    <span className="pname">
      {def && <Sprite asset={{ kind: 'ornament', token: equip.left, side: 'left', seed: def.name }} size={size} decorative />}
      <span className="pname__text">{save.username}</span>
      {def && <Sprite asset={{ kind: 'ornament', token: equip.right, side: 'right', seed: def.name }} size={size} decorative />}
    </span>
  );
}
